import React from "react";
import AddIcon from "@mui/icons-material/Add";
import RightSideModel from "src/components/popup/rightSide/RightSideModel";
import { allowedToCreateEntity } from "src/constants/role";
import useAuth from "src/hooks/useAuth";
import { useGetPermissionAccessControl } from "src/context/PermissionAccessControl";
import Controls from "src/components/form/controls/Controls";
import { isOpenPopup } from "src/utils/isOpenPopup";
import ReleaseSpeakerVersionForm from "../form/ReleaseSpeakerVersionForm/ReleaseSpeakerVersionForm";

const titlePopup = (isEdit) => {
  return isEdit ? "Edit Speaker Version" : "Create Speaker Version";
};

const ReleaseSpeakerVersionPopup = ({
  recordForEdit,
  openPopup,
  setOpenPopup,
  handleOpenPopup,
  addOrEdit,
  errorsForm,
  releaseTypeSpeakerId,
  environmentId,
}) => {
  const { auth } = useAuth();
  const permissionsAccessControl = useGetPermissionAccessControl();
  return (
    <>
      {allowedToCreateEntity(auth?.permissions, permissionsAccessControl) && (
        <Controls.Button
          text="Add New"
          variant="outlined"
          startIcon={<AddIcon />}
          onClick={() => handleOpenPopup(isOpenPopup, null)}
        />
      )}
      <RightSideModel
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        title={titlePopup(Boolean(recordForEdit))}
        width={550}
      >
        <ReleaseSpeakerVersionForm
          recordForEdit={recordForEdit}
          releaseTypeSpeakerId={releaseTypeSpeakerId}
          environmentId={environmentId}
          addOrEdit={addOrEdit}
          errorsForm={errorsForm}
        />
      </RightSideModel>
    </>
  );
};

export default ReleaseSpeakerVersionPopup;
